var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c("div", { staticClass: "media-dialog" }, [
        _c(
          "div",
          { staticClass: "media-dialog__body text-left" },
          [
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.isBusy,
                    expression: "isBusy",
                  },
                ],
                ref: "form",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "element-loading-spinner": "el-icon-loading",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "content" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: "5" },
                      model: {
                        value: _vm.form.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "content", $$v)
                        },
                        expression: "form.content",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary btn-sm px-4",
                on: { click: _vm.close },
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-purple btn-sm px-4",
                attrs: { disabled: !_vm.canStore },
                on: { click: _vm.store },
              },
              [_vm._v("Save changes")]
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }